export function setTotalRow(state){
    state.totalRow = state.datosphp.length
    return state.totalRow
}